import { useParams, useLocation, useNavigate } from 'react-router-dom';
import styles from './TemplateContainer.module.scss';
import { useSelector } from 'react-redux';
import TemplateCard from './TemplateCard/TemplateCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import './styles.scss';
import Editor from './Editor/Editor';
import React, { useState, useEffect } from 'react';
import { createMediaRoomAPI, getMediaRoomByIdAPI, updateMediaRoomAPI } from 'api/mediaRooms';
import { errorToast, successToast } from 'toasts/Toasts';
import ContentSelector from '../ContentSelector/ContentSelector';
import { getCatalogByCollectionIdAPI } from 'api/contentUploadAPI';
import PresSlider from './PresSlider/PresSlider';
import CheckAuthLoadingPage from 'components/pages/CheckAuthLoadingPage/CheckAuthLoadingPage';

export default function TemplateContainer () {
    const { id } = useParams();
    const location = useLocation();
    const isEditing = location.pathname.includes('/media-room/');
    const navigate = useNavigate();
    const templates = useSelector((state) => state.templates.templates);
    const template = templates.find((t) => t.id === Number(id));
    const [selectContent, setSelectContent] = useState(false);
    const [fullscreenSlider, setFullscreenSlider] = useState(false);
    const [mediaRoom, setMediaRoom] = useState(null);
    const [name, setName] = useState('');
    const [editorContent, setEditorContent] = useState({ heading: '', subheading: '' });
    const [loading, setLoading] = useState(false);
    const [isModified, setIsModified] = useState(false);
    const [creatbtn, setCreatebtn] = useState(false);
    const [selectedCollections, setSelectedCollections] = useState([]);
    const [selectedCollectionsperRow, setSelectedCollectionsperRow] = useState([]);
    const [collectionThumbnails, setCollectionThumbnails] = useState({});
    const [selectedCatalogs, setSelectedCatalogs] = useState([]);
    const [preview, setPreview] = useState(false);
    const [backgroundsModal, setBackgroundsModal] = useState(false);
    const [background, setBackground] = useState(null);
    const templateId = isEditing ? mediaRoom?.data?.templateId : template?.id;
    async function fetchMediaRoom () {
        try {
            const data = await getMediaRoomByIdAPI(id);
            setMediaRoom(data);
            setName(data.name);
            setEditorContent({ heading: data.heading, subheading: data.subheading });
            setSelectedCollections(data.data?.collections || []);
            setSelectedCollectionsperRow(data.data?.collectionsperRow || []);
            setBackground(data.backgroundImage);
        } catch (err) {
            errorToast('Failed to fetch Media Room.');
        }
    }
    useEffect(() => {
        if (isEditing && id) {
            fetchMediaRoom();
        }
    }, [isEditing, id]);

    const getFirstItemThumbnail = async (collectionId) => {
        try {
            const response = await getCatalogByCollectionIdAPI(collectionId);
            const catalogsData = response?.data?.data?.result || [];
            return catalogsData.length > 0 ? `https://cdn.publisher.masterwizr.com/${catalogsData[0]?.assest_urls?.[0]?.thumbnail}` : null;
        } catch (error) {
            errorToast(`Failed to fetch thumbnail for collection ${collectionId}:`, error);
            return null;
        }
    };
    const fetchCatalogsForCollection = async (collectionId) => {
        if (!collectionId) return;

        try {
            const response = await getCatalogByCollectionIdAPI(collectionId);
            const catalogsData = response?.data?.data?.result || [];
            setSelectedCatalogs(catalogsData);
            setFullscreenSlider(true);
        } catch (error) {
            errorToast(`Failed to fetch catalogs for collection ${collectionId}:`, error);
        }
    };

    const fetchCollectionThumbnails = async (collections) => {
        if (collections.length === 0) return;

        const newThumbnails = { ...collectionThumbnails };
        await Promise.all(
            collections.map(async (collectionId) => {
                if (!newThumbnails[collectionId]) {
                    const firstItemThumbnail = await getFirstItemThumbnail(collectionId);
                    if (firstItemThumbnail) {
                        newThumbnails[collectionId] = firstItemThumbnail;
                    }
                }
            })
        );
        setCollectionThumbnails(newThumbnails);
    };

    useEffect(() => {
        if (selectedCollections.length > 0) {
            fetchCollectionThumbnails(selectedCollections);
        }
        if (selectedCollectionsperRow.length > 0) {
            fetchCollectionThumbnails(selectedCollectionsperRow);
        }
    }, [selectedCollections, selectedCollectionsperRow]);

    const editingnumberOfItems =
        templates.find((t) => t.id === mediaRoom?.data?.templateId)?.numberOfItems || 1;

    const handleSave = async () => {
        setLoading(true);

        try {
            if (isEditing) {
                await updateMediaRoomAPI(id, {
                    id,
                    name,
                    heading: editorContent.heading,
                    subheading: editorContent.subheading,
                    collections: selectedCollections,
                    collectionsperRow: selectedCollectionsperRow,
                    backgroundImage: background
                });
                successToast('Media Room updated!')
            } else {
                await createMediaRoomAPI({
                    name,
                    heading: editorContent.heading,
                    subheading: editorContent.subheading,
                    templateId: template.id,
                    collections: selectedCollections,
                    collectionsperRow: selectedCollectionsperRow,
                    backgroundImage: background
                });
                successToast('Media Room successfully created!')
            }
        } catch (err) {
            errorToast(err.response?.data?.message || 'Failed to save Media Room.');
        } finally {
            setLoading(false);
            setIsModified(false);
            navigate('/mpublisher/media-rooms');
        }
    };

    const handleEditorChange = (updatedContent) => {
        setEditorContent(updatedContent);
        setIsModified(true);
    };

    if (isEditing && !mediaRoom) return <CheckAuthLoadingPage />;
    if (!isEditing && !template) return <div className='loader'>Template not found</div>;

    if (loading) return <CheckAuthLoadingPage />;

    const numberOfItems = isEditing ? editingnumberOfItems : template?.numberOfItems || 1;
    const bgItems = [
        'https://cdn.cf.masterwizr.com/2c3fa695876141.5ea189704dcda_prabja.jpg',
        'https://cdn.cf.masterwizr.com/bed8c395876141.5ea189704c88a_lvibus.jpg',
        'https://cdn.cf.masterwizr.com/Contemporary_Interior_Design___Vancouver_hbp3td.jpg',
        'https://cdn.cf.masterwizr.com/a95b8c153410253.632f20e2d8546_k1q5qm.jpg'
    ]

    return (
        <>
            <div
            className={`
                ${styles.container} 
                ${preview ? styles.preview : ''}
                ${(mediaRoom?.data?.templateId === 1 || template === 1) 
                ? styles.template1 
                : ''}
                ${(isEditing && (background === undefined || background === null) && mediaRoom?.data?.backgroundImage !== null) || !(background === undefined || background === null) 
                ? styles.bgBlur 
                : ''}
            `}
            >
                <div
                    style={{
                        backgroundImage: `url(${(isEditing && (background === undefined || background === null)) ? mediaRoom?.data?.backgroundImage : (background !== null || background !== undefined) ? background : null
                            })`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                    className={styles.shade} />

                <Editor
                    template={isEditing ? mediaRoom?.data : template}
                    editorContent={editorContent}
                    setEditorContent={handleEditorChange}
                    setSelectContent={setSelectContent}
                    preview={preview}
                    setBackgroundsModal={setBackgroundsModal}
                    backgroundsModal={backgroundsModal}
                    extraClass={
        `editor${templateId}`
                      }                      
                />

                {backgroundsModal &&
                    <div className={styles.bgmodal}>
                        <h2>Choose Background Image</h2>
                        <div className={styles.items}>
                            {bgItems.map((item, index) => (
                                <div
                                    key={index}
                                    className={
                                        `${styles.item
                                        } ${background === item ? styles.selected : ''
                                        }`
                                    }
                                    onClick={() => {
                                        setBackground(item);
                                    }}
                                >
                                    <img src={item
                                    } alt='Background Image' />
                                </div>
                            ))
                            }
                        </div>
                    </div>
                }
                    <div className={`${styles.swiperWrapper} ${styles[`template${templateId}`]}`}>
                        <Swiper
                            className={styles.swiper}
                            modules={[Navigation]}
                            spaceBetween={20}
                            slidesPerView={numberOfItems}
                            navigation
                        >

                            {Array.from({ length: numberOfItems }).map((_, index) => {
                                const collectionId = selectedCollections[index];

                                return (
                                    <SwiperSlide key={index} onClick={() => fetchCatalogsForCollection(collectionId)}>
                                        <TemplateCard
                                            image={collectionThumbnails[collectionId]}
                                            templateId={templateId}
                                        />
                                    </SwiperSlide>
                                );
                            })}

                        </Swiper>
                    </div>
                    {(templateId === 6 || templateId === 7) &&
                       <div className={`${styles.swiperWrapper} ${styles[`template${templateId}`]}`}>
                       <Swiper
                           className={styles.swiper}
                           modules={[Navigation]}
                           spaceBetween={20}
                           slidesPerView={numberOfItems}
                           navigation
                       >

                           {Array.from({ length: numberOfItems }).map((_, index) => {
                               const collectionId = selectedCollectionsperRow[index];

                               return (
                                   <SwiperSlide key={index} onClick={() => fetchCatalogsForCollection(collectionId)}>
                                       <TemplateCard
                                           image={collectionThumbnails[collectionId]}
                                           templateId={templateId}

                                       />
                                   </SwiperSlide>
                               );
                           })}

                       </Swiper>
                   </div>
                    }
                <div className={styles.bottomButtons}>
                    {isEditing && !preview && <button
                            onClick={handleSave}
                            disabled={loading || !isModified}
                            className={styles.createButton}
                        >
                            {loading ? 'Saving...' : isEditing ? 'Save' : 'Create Media Room'}
                        </button>
                    }
                    {!preview &&
                        <button
                            onClick={() => setPreview(true)}
                            className={styles.createButton}
                        >
                            Preview
                        </button>
                    }
                    {!isEditing && !preview &&
                        <button
                            onClick={() => setCreatebtn(true)}
                            className={styles.createButton}
                        >
                            {'Create Media Room'}
                        </button>
                    }
                    {preview &&
                        <button
                            onClick={() => setPreview(false)}
                            className={styles.createButton}
                        >
                            Exit Preview
                        </button>
                    }
                </div>
                {creatbtn &&
                    <div className={styles.popup}>
                        <div className={styles.frame}>
                            <input
                                type='text'
                                placeholder='Enter Media Room Name'
                                value={name}
                                onChange={(e) => {
                                    setName(e.target.value);
                                    setIsModified(true);
                                }}
                                className={styles.input}
                            />
                            <div className={styles.buttons}>
                                <button
                                    onClick={() => setCreatebtn(false)}
                                >Cancel</button>
                                <button
                                    onClick={handleSave}
                                >
                                    {loading ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div style={{ display: selectContent ? 'block' : 'none' }} >
                <ContentSelector
                    selectContent={selectContent}
                    setSelectContent={setSelectContent}
                    selectedCollections={selectedCollections}
                    setSelectedCollections={setSelectedCollections}
                    numberOfItems={isEditing ? editingnumberOfItems : template?.numberOfItems || 1}
                    selectedCollectionsperRow={selectedCollectionsperRow}
                    setSelectedCollectionsperRow={setSelectedCollectionsperRow}
                    templateId={templateId}
                />
            </div>

            {
                fullscreenSlider &&
                <PresSlider
                    catalogsData={selectedCatalogs}
                    onClose={() => setFullscreenSlider(false)}
                />
            }
        </>
    );
}
